export default __webpack_public_path__ + "static/Gibson-SemiBold-48e4fc2935efcdbbe67fc7b58c9d9090.woff";